<template>
  <div class="kiosk-home">
    <div class="kiosk-header">
      <img src="/elite-logo-white.png" alt="Elite Fitness" class="kiosk-logo" />
      <p>Benvenuto. Come possiamo aiutarti?</p>
    </div>

    <div class="kiosk-cards">
      <button class="kiosk-card" @click="goPayOrder">
        <span class="kiosk-card__icon">🧾</span>
        <span class="kiosk-card__title">Paga il tuo ordine</span>
        <span class="kiosk-card__desc">Hai già un ordine? Scansiona il QR ricevuto via email e paga in cassa.</span>
      </button>

      <button class="kiosk-card" @click="goBuy">
        <span class="kiosk-card__icon">🏋️</span>
        <span class="kiosk-card__title">Acquista un servizio</span>
        <span class="kiosk-card__desc">Abbonamenti, corsi, personal training e altro.</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { kioskSession } from '@/config/kioskSession'

const router = useRouter()

/**
 * La home è il punto di passaggio obbligato di OGNI uscita dal totem: fine
 * vendita, timeout di inattività, annullamento, tasto indietro. Ripulire qui la
 * sessione garantisce che il totem torni anonimo comunque sia finita la
 * sessione precedente — senza, un checkout non concluso lascerebbe il socio
 * loggato e il cliente successivo comprerebbe a suo nome, saltando lo Step 2.
 */
onMounted(() => {
  kioskSession.userName = ''
  try {
    localStorage.removeItem('userEmail')
    localStorage.removeItem('userToken')
    localStorage.removeItem('tokenExpiration')
  } catch (e) {
    /* storage non disponibile: nulla da ripulire */
  }
})

function goPayOrder() {
  // In modalità kiosk OrderConfirmationPage non richiede userToken:
  // l'autenticazione verso il backend la fa il gateway (window.kioskPay, HMAC).
  router.push({ path: '/order-confirmation' })
}

function goBuy() {
  router.push({ path: '/services-flow', query: { source: 'kiosk' } })
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

.kiosk-home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  padding: 2rem;
  font-family: 'Montserrat', sans-serif;
  background: #2e348c;
  color: #fff;
  text-align: center;
}

.kiosk-header h1 {
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
}

.kiosk-logo {
  width: 320px;
  max-width: 70vw;
  height: auto;
  margin: 0 auto 1rem;
  display: block;
}

.kiosk-header p {
  font-size: 1.4rem;
  opacity: 0.85;
  margin: 0;
}

.kiosk-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  width: 100%;
  max-width: 900px;
}

.kiosk-card {
  flex: 1 1 320px;
  max-width: 400px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2.5rem 2rem;
  border: none;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  transition: transform 0.12s ease, background 0.12s ease;
}

.kiosk-card:active {
  transform: scale(0.97);
  background: rgba(255, 255, 255, 0.16);
}

.kiosk-card__icon {
  font-size: 4rem;
}

.kiosk-card__title {
  font-size: 1.7rem;
  font-weight: 700;
}

.kiosk-card__desc {
  font-size: 1.1rem;
  opacity: 0.8;
  line-height: 1.4;
}

.kiosk-footer {
  font-size: 1rem;
  opacity: 0.6;
  margin: 0;
}
</style>
